import {SubNav} from '@primer/react-brand'
import {useEffect, useState} from 'react'
import type {PrimerComponentSubnav} from '../../../lib/types/contentful'
import {isCurrentLink} from './utils'

export type ContentfulSubnavProps = {
  component: PrimerComponentSubnav

  hasShadow?: boolean
}

export function ContentfulSubnav({component, ...props}: ContentfulSubnavProps) {
  const [actualUrl, setActualUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    setActualUrl(window.location.href)
  }, [])

  return (
    <SubNav hasShadow={props.hasShadow}>
      <SubNav.Heading href={component.fields.heading.fields.href}>
        {component.fields.heading.fields.text}
      </SubNav.Heading>

      {component.fields.links.map(link => {
        const isCurrent = isCurrentLink({url: link.fields.href, actual: actualUrl})

        return (
          <SubNav.Link key={link.sys.id} href={link.fields.href} {...(isCurrent ? {'aria-current': 'page'} : {})}>
            {link.fields.text}
          </SubNav.Link>
        )
      })}

      {component.fields.cta !== undefined && (
        <SubNav.Action href={component.fields.cta.fields.href}>{component.fields.cta.fields.text}</SubNav.Action>
      )}
    </SubNav>
  )
}

try{ ContentfulSubnav.displayName ||= 'ContentfulSubnav' } catch {}